var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TextBody',{attrs:{"custom-class":"mb-4","text":_vm.t$('.text')}}),_vm._v(" "),_c('Button',{staticClass:"mt-4",on:{"click":_vm.scrollToPostform}},[_vm._v("Fotos hochladen")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }